import { SYNC_FORM_REVIEW_DATA } from './';

export default (data, state) => ({
  type: SYNC_FORM_REVIEW_DATA,
  payload: { data, state },
});
